import React, { useRef, useState } from 'react';
import { noop } from 'lodash';

import ElearningTestFeature from '@features/elearning-test';
import VideoFeature from '@features/video';
import {
  useElearningWpOnSiteElearningAccept,
  useElearningWpOnSiteFinish,
  useElearningWpOnSiteSubmitTest,
  useElearningWpOnSiteTestQuery
} from '@services/elearning-wp-onsite';
import { useVismaConfiguration } from '@services/visitor-management';

import { useElearningWpOnSiteFlow } from './shared/ewos-flow-context';
import { ROUTES } from '@constants/routes';
import { useNavigate } from 'react-router-dom';

function ElearningWpOnSiteTestSection() {
  const { data: questions, isLoading: isLoadingQuestions } =
    useElearningWpOnSiteTestQuery();
  const submitMutation = useElearningWpOnSiteSubmitTest();
  const finishMutation = useElearningWpOnSiteFinish();
  return (
    <ElearningTestFeature
      questions={questions ?? []}
      isLoading={
        isLoadingQuestions ||
        submitMutation.isPending ||
        finishMutation.isPending
      }
      onSubmit={(testAnswers) => submitMutation.mutateAsync({ testAnswers })}
      onNext={() => finishMutation.mutateAsync().catch(noop)}
    />
  );
}

function ElearningWpOnSiteVideoPage() {
  const { goBack } = useElearningWpOnSiteFlow();
  const { configuration } = useVismaConfiguration();
  const hasTest =
    configuration?.elearningTestData?.compliance_test_has === 'yes';
  const [videoAccepted, setVideoAccepted] = useState(false);
  const acceptMutation = useElearningWpOnSiteElearningAccept();
  const finishMutation = useElearningWpOnSiteFinish();
  const testSectionRef = useRef<HTMLDivElement>(null);
  const navigate = useNavigate();

  const onElearningComplete = async (accepted: boolean) => {
    await acceptMutation.mutateAsync(accepted);
    if (!accepted) return navigate(ROUTES.EWOS_MVE);
    if (!hasTest) return void finishMutation.mutateAsync().catch(noop);

    setVideoAccepted(true);
    setTimeout(() => {
      testSectionRef.current?.scrollIntoView({ behavior: 'smooth' });
    }, 500);
  };

  return (
    <VideoFeature
      onElearningComplete={onElearningComplete}
      isLoading={acceptMutation.isPending || finishMutation.isPending}
      onPreviousPage={goBack}
    >
      {videoAccepted && (
        <div ref={testSectionRef}>
          <ElearningWpOnSiteTestSection />
        </div>
      )}
    </VideoFeature>
  );
}

export default ElearningWpOnSiteVideoPage;
